/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TipiInterventoResponseDTO,
} from '../models/index';
import {
    TipiInterventoResponseDTOFromJSON,
    TipiInterventoResponseDTOToJSON,
} from '../models/index';

/**
 * 
 */
export class TipiInterventoApi extends runtime.BaseAPI {

    /**
     */
    async getTipiInterventoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TipiInterventoResponseDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/TipiIntervento`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TipiInterventoResponseDTOFromJSON));
    }

    /**
     */
    async getTipiIntervento(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TipiInterventoResponseDTO>> {
        const response = await this.getTipiInterventoRaw(initOverrides);
        return await response.value();
    }

}
